import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { AuthorTag } from '@contracts';
import Colors from './Colors';

interface Props {
  name: string;
  tags: string[] | AuthorTag[];
  HeadingComponent?: React.ComponentType<{ children: React.ReactNode }>;
}

const SpecialistHelpsWithTags: React.FC<Props> = ({ name, tags, HeadingComponent }) => {
  const { t } = useTranslation();
  const mappedTags = tags.map((tag) => {
    let text = '';
    if (typeof tag === 'string') {
      text = tag;
    } else {
      text = tag.tag ?? '';
    }
    return text;
  });

  const hasTags = mappedTags.every((tag) => tag.length > 0);
  if (!hasTags) {
    return null;
  }

  return (
    <Container>
      <HeadingContainer>
        {HeadingComponent ? (
          <HeadingComponent>{`${name} ${t('screening.specialist-help-you-with')}:`}</HeadingComponent>
        ) : (
          <HelpWithHeading className="help-with-heading">{`${name} ${t('screening.specialist-help-you-with')}:`}</HelpWithHeading>
        )}
      </HeadingContainer>
      <HelpWithTags>
        {mappedTags.map((tag, index) => {
          return tag.length > 0 ? (
            <div key={index} className="help-with-tag">
              {tag}
            </div>
          ) : null;
        })}
      </HelpWithTags>
    </Container>
  );
};

export default SpecialistHelpsWithTags;

const Container = styled.div``;

const HeadingContainer = styled.div`
  margin-bottom: 16px;
`;

const HelpWithHeading = styled.p`
  font-family: 'BrownStd';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: ${Colors.navyBlue};
`;

const HelpWithTags = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 6px;

  & div {
    display: flex;
    padding: 6px 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: 20px;
    background: ${Colors.mint};

    font-family: 'BrownStd';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: ${Colors.navyBlue};
  }
`;
